module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_morschach-aca53ed2bb6e072edc53ea9bd4a8f070.png";